export default __webpack_public_path__ + "static/media/image_sensors.53e928ae.svg";